module.exports = __webpack_public_path__ + "media/images/icons/filled/dingtalk-square-d36a5124e933fb4e48a984c2ae7ffab4.svg";